module.exports = Odigeo.Model.extend({
    defaults: {
        section: 0,
        numPassenger: 0,
        floorSelection: 0,
        rowSelection: 0,
        seatMapRow: 0,
        columnSelection: '',
        providerPrice: 0,
        totalPrice: 0,
        totalPrimePrice: 0,
        currencyCode: '',
    },
    segment: 0,
    idModel: '',
    idAttribute: 'idModel',

    parse(response) {
        response.floorSelection = parseInt(response.floorSelection);
        response.rowSelection = parseInt(response.rowSelection);
        return response;
    },
});
